export default "__VITE_ASSET__e850d355__"